export function initExpandsets() {
    const expandsets = document.querySelectorAll("[data-expandset]");

    for (const expandset of expandsets) {
        initExpandset(expandset);
    }
}

export function initExpandset(expandset) {
    const summary = expandset?.querySelector("summary");
    summary?.addEventListener("click", (e) => {
        e.preventDefault();

        const { group } = expandset.dataset;

        if (group) {
            const groupExpandsets = document.querySelectorAll(
                `[data-expandset][data-group="${group}"]`,
            );

            for (const groupExpandset of groupExpandsets) {
                if (groupExpandset !== expandset) {
                    closeExpandset(groupExpandset);
                }
            }
        }

        if (expandset.open) {
            closeExpandset(expandset);
        } else {
            openExpandset(expandset);
        }
    });
}

function closeExpandset(expandset) {
    expandset.classList.add("transitioning");

    const { expandsetAnimated } = expandset.dataset;

    if (expandsetAnimated) {
        expandset.classList.remove("is-open");
        window.setTimeout(() => {
            expandset.removeAttribute("open");
            expandset.classList.remove("transitioning");
        }, 300);
    } else {
        expandset.removeAttribute("open");
    }
}

function openExpandset(expandset) {
    expandset.classList.add("transitioning");
    const { expandsetAnimated } = expandset.dataset;

    if (expandsetAnimated) {
        expandset.setAttribute("open", true);
        window.setTimeout(() => {
            expandset.classList.add("is-open");
        }, 0);
    } else {
        expandset.setAttribute("open", true);
    }

    window.setTimeout(() => {
        expandset.classList.remove("transitioning");
    }, 300);
}
